var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7292 11.2447H13.693C12.5781 11.244 11.6745 10.3411 11.6738 9.22622C11.6738 8.11139 12.5781 7.20845 13.693 7.20776H16.7292",
    stroke: "#43424A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0368 9.18008H13.803",
    stroke: "#43424A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31075 2.69788H12.7933C14.9669 2.69788 16.7291 4.46001 16.7291 6.63362V12.0164C16.7291 14.19 14.9669 15.9521 12.7933 15.9521H6.31075C4.13713 15.9521 2.375 14.19 2.375 12.0164V6.63362C2.375 4.46001 4.13713 2.69788 6.31075 2.69788Z",
    stroke: "#43424A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77637 6.10153H9.82558",
    stroke: "#43424A",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIconLight);
export default __webpack_public_path__ + "static/media/balance_icon_light.8fec8360b638b2e512b3099902326a09.svg";
export { ForwardRef as ReactComponent };